<template>
    <div class="lang">
        <div class="reservation-lang">
            <div class="info">
                <h3 class="bullet01">Өвчтөний мэдээлэл</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> Өвчтөний бүртгэлийн дугаар <br>
                                    (Зөвхөн давтан үзүүлж буй өвчтөн)</div>
                                <div class="cont"><input type="text" class="input" placeholder="Өвчтөний бүртгэлийн дугаар" v-model="params.ptNo" ref="ptNo"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> Нэр</div>
                                <div class="cont item2">
                                    <input type="text" class="input" placeholder="Нэр" v-model="params.firstName" ref="firstName">
                                    <input type="text" class="input" placeholder="Овог" v-model="params.lastName" ref="lastName">
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> Хүйс</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  >
                                            <input type="radio" name="gender1" id="gender1" value="M" v-model="params.gender">
                                            <span class="radio-btn"></span>
                                            <p>Эрэгтэй</p>
                                        </label>
                                        <label  >
                                            <input type="radio" name="gender2" id="gender2" value="F" v-model="params.gender">
                                            <span class="radio-btn"></span>
                                            <p>Эмэгтэй</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Төрсөн он сар өдөр</div>
                                <div class="cont"><input type="text" class="input" placeholder="ex)19800320" v-model="params.birth" ref="birth" maxlength="8"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Иргэний харьяалал</div>
                                <div class="cont"><input type="text" class="input" v-model="params.national" ref="national"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> Хэл</div>
                                <div class="cont"><input type="text" class="input" v-model="params.language" ref="language"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> Оршин суугаа улс</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  >
                                            <input type="radio" name="country1" id="country1" value="K" v-model="params.countryGubun">
                                            <span class="radio-btn"></span>
                                            <p>БНСУ</p>
                                        </label>
                                        <label  >
                                            <input type="radio" name="country2" id="country2" value="O" v-model="params.countryGubun">
                                            <span class="radio-btn"></span>
                                            <p>Бусад</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">Эх орон дахь хаяг</div>
                                <div class="cont"><input type="text" class="input" v-model="params.addressHome"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Солонгос дахь хаяг</div>
                                <div class="cont"><input type="text" class="input" v-model="params.address" ref="address"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Утасны дугаар</div>
                                <div class="cont">
                                    <input type="text" class="input" v-model="params.hpNo" ref="hpNo">
                                    <!-- <p>- Please leave korean phone number or email address.</p> -->
                                </div>

                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">Яаралтай үед холбогдох утасны дугаар</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">Нэр</div><input type="text" class="input" v-model="params.emergencyNm">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">Өвчтөнтэй ямар холбоотой болох</div><input type="text" class="input" v-model="params.emergencyPatRelation">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">Утасны дугаар</div><input type="text" class="input" v-model="params.emergencyHpNo">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Даатгалын мэдээлэл</div>
                                <div class="cont"><input type="text" class="input" v-model="params.insuranceInfo" ref="insuranceInfo"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="info">
                <h3 class="bullet01">Томилгоо дэлгэрэнгүй мэдээлэл</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Өвчний шинж тэмдэг <br>
                                    (үзлэгийн цаг захиалах болсон шалтгаан)</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea" v-model="params.symptoms" ref="symptoms"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> Шаардлагатай эрүүл мэндийн үйлчилгээ</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea" v-model="params.mediServiceReq" ref="mediServiceReq"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> Сонгосон огноо, цаг</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">1 дэх</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="preDate1" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply/>
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select01 }" @click.prevent="activeselect01">{{params.rsvhour1 ? params.rsvhour1 : 'Цаг сонгоно уу'}}</a>
                                                    <slide-up-down :active="select01" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 23" :key="i" @click="[params.rsvhour1 = i, activeselect01()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select02 }" @click.prevent="activeselect02">{{params.rsvmin1 ? params.rsvmin1 : 'Минутыг сонгоно уу'}}</a>
                                                    <slide-up-down :active="select02" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 59" :key="i" @click="[params.rsvmin1 = i, activeselect02()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">2 дахь</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="preDate2" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply/>
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select03 }" @click.prevent="activeselect03">{{params.rsvhour2 ? params.rsvhour2 : 'Цаг сонгоно уу'}}</a>
                                                    <slide-up-down :active="select03" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 23" :key="i" @click="[params.rsvhour2 = i, activeselect03()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select04 }" @click.prevent="activeselect04">{{params.rsvmin2 ? params.rsvmin2 : 'Минутыг сонгоно уу'}}</a>
                                                    <slide-up-down :active="select04" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 59" :key="i" @click="[params.rsvmin2 = i, activeselect04()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">Эмнэлгийн дүгнэлтийг хавсаргана уу</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;" v-model="params.uploadFileName">
                                    <label class="file">
                                        <input type="file" accept=".txt, .pdf, .hwp, .docx, .jpg, .png, .gif" @change="onFileChange($event.target, 'uploadFile')">
                                        <div class="main-button c-gray">Файл хавсаргах</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">Холбоосыг хавсаргана уу</div>
                                <div class="cont">
                                    <input type="text" class="input" v-model="params.attachLink">
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">Зургийг хавсаргана</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;" v-model="params.uploadImgName">
                                    <label class="file">
                                        <input type="file" accept=".jpg, .png, .gif" @change="onFileChange($event.target, 'uploadImg')">
                                        <div class="main-button c-gray">Файл хавсаргах</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="botton-wrap">
                    <a href="javascript:;" class="sub-button c-gray" @click="cancelReservation">Үгүй</a>
                    <a href="javascript:;" class="main-button c-main" @click="simpleAction">Тийм</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import SlideUpDown from 'vue-slide-up-down';

export default{
    components: {
        VueDatePicker,
        SlideUpDown,
    },
    data() {
        return {
            preDate1: null,
            preDate2: null,
            formatDate: 'yyyy-MM-dd', // 원하는 날짜 형식 설정
            select01: false,
            select02: false,
            select03: false,
            select04: false,

            // 예약 데이터
            params: {
                gender: 'M',
                countryGubun: 'K',
                rsvhour1: '',
                rsvmin1: '',
                rsvhour2: '',
                rsvmin2: ''
            }
        };
    },
    methods: {
        onFileChange(target, str){
            const file = target.files
            if(file.length > 0){
                this.params[str] = file[0]
                this.params[str + 'Name'] = file[0].name
            }
        },
        simpleAction(){
            if (!this.params.ptNo) {
                alert("Өвчтөний бүртгэлийн дугаар оруулна уу.");
                this.$refs.ptNo.focus();
                return false;
            }
            
            if (!this.params.firstName) {
                alert("Нэр оруулна уу.");
                this.$refs.firstName.focus();
                return false;
            }
            
            if (!this.params.lastName) {
                alert("Овог оруулна уу.");
                this.$refs.lastName.focus();
                return false;
            }
            
            if (!this.params.birth) {
                alert("Төрсөн он сар өдөр оруулна уу.");
                this.$refs.birth.focus();
                return false;
            } else {
                var birthExp = /^(19[0-9][0-9]|20\d{2})-?(0[0-9]|1[0-2])-?(0[1-9]|[1-2][0-9]|3[0-1])$/;
                if(!birthExp.test(this.params.birth)) {
                    alert("Төрсөн он сар өдөр буруу байна.");
                    this.$refs.birth.focus();
                    return false;
                }
            }
            
            if (!this.params.national) {
                alert("Таны иргэний харьяаллыг оруулна уу.");
                this.$refs.national.focus();
                return false;
            }
            
            if (!this.params.language) {
                alert("Таны Хэл оруулна уу.");
                this.$refs.language.focus();
                return false;
            }
            
            if (!this.params.address) {
                alert("Таны Солонгос дахь хаяг оруулна уу.");
                this.$refs.address.focus();
                return false;
            }
            
            if (!this.params.hpNo) {
                alert("Таны Утасны дугаар оруулна уу.");
                this.$refs.hpNo.focus();
                return false;
            }
            
            if (!this.params.insuranceInfo) {
                alert("Таны Даатгалын мэдээлэл оруулна уу.");
                this.$refs.insuranceInfo.focus();
                return false;
            }
            
            if (!this.params.symptoms) {
                alert("Таны Өвчний шинж тэмдэг оруулна уу.");
                this.$refs.symptoms.focus();
                return false;
            }
            
            if (!this.params.mediServiceReq) {
                alert("Таны шаардлагатай үйлчилгээ оруулна уу.");
                this.$refs.mediServiceReq.focus();
                return false;
            }
            
            if (!this.preDate1) {
                alert("Таны Хүссэн эхний захиалга хийх огноо оруулна уу.");
                return false;
            }
            
            if (!this.params.rsvhour1) {
                alert("Таны Хүссэн эхний захиалга хийх огноо оруулна уу.");
                return false;
            }
            
            if (!this.params.rsvmin1) {
                alert("Таны Хүссэн эхний захиалга хийх огноо оруулна уу.");
                return false;
            }
            
            if (!this.preDate2) {
                alert("Таны Хүссэн хоёр дахь захиалга хийх огноо оруулна уу.");
                return false;
            }
            
            if (!this.params.rsvhour2) {
                alert("Таны Хүссэн хоёр дахь захиалга хийх огноо оруулна уу.");
                return false;
            }
            
            if (!this.params.rsvmin2) {
                alert("Таны Хүссэн хоёр дахь захиалга хийх огноо оруулна уу.");
                return false;
            }

            this.params.rsvDat1 = this.preDate1.toISOString().split('T')[0]
            this.params.rsvDat2 = this.preDate2.toISOString().split('T')[0]
            this.params.rsvhour1 = ('0' + (this.params.rsvhour1)).slice(-2);
            this.params.rsvhour2 = ('0' + (this.params.rsvhour2)).slice(-2);
            this.params.rsvmin1 = ('0' + (this.params.rsvmin1)).slice(-2);
            this.params.rsvmin2 = ('0' + (this.params.rsvmin2)).slice(-2);
            const urlParam = new URLSearchParams(this.params).toString();
            
            const formData = new FormData();

            // 기존 params의 내용 (파일 외의 다른 데이터) 추가
            Object.keys(this.params).forEach(key => {
                if (key !== 'uploadFile' && this.params[key] !== null) {
                    formData.append(key, this.params[key]);
                }
            });
            if (this.params.uploadFile) {
                formData.append('uploadFile', this.params.uploadFile);
            }

            const param = {langCd: this.$store.getters.getLang}
            this.axios.post(this.api.glb.reservation, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params: param
            })
            .then(response => {
                const data =response.data
                if (data.result == "success") {
					alert("Захиалгын хүсэлт дууссан байна.");
					// location.href = `/${this.$store.getters.getLang}/main`;
				} else {
					alert("Захиалгын хүсэлт амжилтгүй боллоо.");
					return false;
				}
            }).catch(err => {
                alert('오류가 발생했습니다. 다시 시도해주시길 바랍니다.')
            });
        },
        cancelReservation(){
            if(confirm("Do you really want to cancel?")){
                location.href = `/${this.$store.getters.getLang}/main`;
            }
        },
        activeselect01() {
            this.select01 = !this.select01;
        },
        activeselect02() {
            this.select02 = !this.select02;
        },
        activeselect03() {
            this.select03 = !this.select03;
        },
        activeselect04() {
            this.select04 = !this.select04;
        },
    },
    mounted() {
        
    },
}
</script>
